module.exports = __webpack_public_path__ + "static/media/BG_Where_V1.7e67ccab.jpg";